
export class ReportGenerator {
    constructor(
        public id: number = null,
        public suiteId: number = null,
        public suiteNumber: string = '',
        public returningByName: string = '',
        public buildingId: number = null,
        public buildingName: string = '',
        public residentId: number = null,
        public residentFullName: string = '',
        public otherResident: string = '',
        public otherSuite: string = '',
        public status: string = '',
        public notes: string = '',
        public purpose: string = '',
        public keyTag: string = '',
        public user: string = '',
        public activityNotes: string = '',
        public isCanEdit: boolean = true,
        public isCanDelete: boolean = true,
        //
        public name: string = '',
        public description: string = '',
        public section: string = '',
        public type: string = 'list',
        public fieldsToShow: Array<any> = [],
        public groupBy: Array<any> = [],
        public orderBy: string = '',
        public orderByDirection: string = '',
        public pageOrientation: string = '',
        public graph: string = '',
        public conditions: Array<any> = [],
        public filters: Array<any> = []
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/ReportGenerator.ts